import PropTypes from "prop-types";

const _Sizes = PropTypes.shape({
  thumbnail: PropTypes.string,
  "thumbnail-width": PropTypes.number,
  "thumbnail-height": PropTypes.number,
  "16:9": PropTypes.string,
  "16:9-width": PropTypes.number,
  "16:9-height": PropTypes.number,
  "1:1": PropTypes.string,
  "1:1-width": PropTypes.number,
  "1:1-height": PropTypes.number,
  "3:2": PropTypes.string,
  "3:2-width": PropTypes.number,
  "3:2-height": PropTypes.number,
  hero: PropTypes.string,
  "hero-width": PropTypes.number,
  "hero-height": PropTypes.number,
  thumb: PropTypes.string,
  "thumb-width": PropTypes.number,
  "thumb-height": PropTypes.number,
});

const _background_gradient_group = PropTypes.shape({
  background_gradient_direction: PropTypes.string,
  background_gradient_end_color: PropTypes.string,
  background_gradient_end_opacity: PropTypes.string,
  background_gradient_start_color: PropTypes.string,
  background_gradient_start_opacity: PropTypes.string,
});

const _background_solid_color_group = PropTypes.shape({
  background_solid_color: PropTypes.string,
  background_solid_color_opacity: PropTypes.string,
});

export const _BackgroundFile = PropTypes.shape({
  ID: PropTypes.number,
  id: PropTypes.number,
  title: PropTypes.string,
  filename: PropTypes.string,
  filesize: PropTypes.number,
  url: PropTypes.string,
  link: PropTypes.string,
  alt: PropTypes.string,
  author: PropTypes.string,
  description: PropTypes.string,
  caption: PropTypes.string,
  name: PropTypes.string,
  status: PropTypes.string,
  uploaded_to: PropTypes.number,
  date: PropTypes.string,
  modified: PropTypes.string,
  menu_order: PropTypes.number,
  mime_type: PropTypes.string,
  type: PropTypes.string,
  subtype: PropTypes.string,
  icon: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  sizes: _Sizes,
});

export const _Background_Component = PropTypes.shape({
  background_3d_model_file: PropTypes.oneOfType([_BackgroundFile, PropTypes.any]),
  background_3d_model: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
  background_color: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
  background_embed: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
  background_gradient_group: _background_gradient_group,
  background_image_min_height: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
  background_image_position: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
  background_image: PropTypes.oneOfType([_BackgroundFile, PropTypes.any]),
  background_solid_color_group: _background_solid_color_group,
  background_type: PropTypes.string,
  background_video: PropTypes.oneOfType([_BackgroundFile, PropTypes.any]),
});

const _Background = PropTypes.shape({
  asBackground: PropTypes.bool,
  ..._Background_Component,
});

export const BackgroundPropTypes = PropTypes.oneOfType([_Background, PropTypes.any]);
